<template lang="pug">
div 
    a-modal(title="添加AUM" v-model="addVisible" @ok="addAum" @cancel="addVisible = false"
        ok-text="添加" cancel-text="取消")
        span 开始时间:
        a-date-picker(v-model="startDate" placeholder="选择日期" style="margin-bottom: 15px;margin-left: 5px")
        a-table(:columns="editColumns" 
            size="small"
            bordered
            :data-source="aums" 
            row-key="bookName" 
            :pagination="false")
            template(slot="aum" slot-scope="text, record, index")
                a-input-number(v-model="record.aum" :min="0" :step="0.01" style="width: 150px;")

    a-button(type="primary" @click="addVisible = true" style="margin-bottom: 15px")
        a-icon(type="plus")
        span 添加AUM更新时间点

    a-collapse 
        a-collapse-panel(v-for="a in items" :key="a[0]" :header="a[0]")
            a-table(:columns="columns" 
                size="small"
                bordered
                :data-source="a[1]" 
                row-key="startDate" 
                :pagination="false")
                template(slot="del" slot-scope="record")
                    a-button(type="danger" @click="deleteAum(record.bookName, record.startDate)")
                        a-icon(type="delete")
                        span 删除


    
</template>

<script>
import _ from 'lodash';
import moment from 'moment/moment';

export default {
    data() {
        return {
            editColumns: [
                {
                    title: 'BookName',
                    dataIndex: 'bookName',
                    key: 'bookName'
                },
                {
                    title: 'AUM',
                    dataIndex: 'aum',
                    key: 'aum',
                    scopedSlots: { customRender: 'aum' },
                }
            ],
            startDate: moment(),
            aums: [],
            addVisible: false,
            items: [],
            columns: [
                {
                    title: '开始时间',
                    dataIndex: 'startDate',
                    key: 'startDate'
                },
                {
                    title: 'bookName',
                    dataIndex: 'bookName',
                    key: 'bookName'
                },
                {
                    title: 'AUM',
                    dataIndex: 'aum',
                    key: 'aum'
                },
                {
                    title: '操作',
                    key: 'del',
                    scopedSlots: { customRender: 'del' },
                }
            ]
        }
    },
    mounted() {
        this.getData();
        this.getBookNames();
    },
    methods: {
        getBookNames() {
            this.$api.request('GET', 'hkoption/booknames')
                .then(res => {
                    this.aums = res.data.map(i => {
                        return {
                            bookName: i.name,
                            aum: 0,
                        }
                    });
                })
        },
        addAum() {
            this.$api.request('POST', 'hkoption/aum', {
                startDate: this.startDate.format("YYYY-MM-DD"),
                aums: this.aums.map(i => {
                    return {
                        bookName: i.bookName,
                        aum: i.aum,
                    }
                }).filter(i => i.aum > 0)
            })
            .then(res => {
                this.addVisible = false;
                this.getData();
            })
            .catch(err => {
                this.$message.error('添加失败:' + err.response.data);
            })
        },
        getData() {
            this.$api.request('GET', 'hkoption/aums')
                .then(res => {
                    this.items = res.data.map(i => {
                        return [i[0], _.sortBy(i[1], 'startDate')]
                    });
                })
        },
        deleteAum(bookName, date) {
            this.$api.request('DELETE', `hkoption/aum/${bookName}/${date}`)
            .then(res => {
                this.getData();
            });
        }
    }
}
</script>